module.exports = __webpack_public_path__ + "img/yan9.2488ff02.png";